import { Injectable } from '@angular/core';
import { reject, resolve } from 'cypress/types/bluebird';
import { CreditCardDTO } from 'src/app/shared/model/dto/CreditCardDTO';

import { ApiService } from './api.service';
import { FingerprintService } from './fingerprint.service';
import { RestaurantService } from './restaurant.service';
import { UtilsService } from './utils.service';

/**
 * `providedIn: 'root'` em vez de entrada no `CoreModule.providers`: o singleton é o mesmo, mas
 * o bundler passa a colocar este serviço no chunk de quem o INJETA. Listado no CoreModule, ele
 * viajava no `main.js` do boot — e esta tela só aparece depois de vários gestos.
 */
@Injectable({ providedIn: 'root' })
export class ConvenixService {

    public baseUrl: string = `/restaurant/${this.restaurantService.restaurant.info.id}/convenix/sale`;

    constructor(
        private apiService: ApiService,
        private restaurantService: RestaurantService,
    ) { 

    }

    getConfirmationCode(clientCPF, sale): Promise<object> {
        return new Promise((resolve, reject) => {
            return this.apiService.post(this.baseUrl, {
                clientCPF: clientCPF,
                sale: {
                    value: sale.value,
                    discount: sale.discount ?? 0,
                }
            }).subscribe(result => {
                resolve(result);
            }, error => {
                reject(error);
            });
        });
    }

    approveConfirmationCode(saleID, saleConfirmationCode): Promise<object> {
        return new Promise((resolve, reject) => {
            return this.apiService.post(this.baseUrl + '/approve', {
                saleID: saleID,
                saleConfirmationCode: saleConfirmationCode
            }).subscribe(result => {
                resolve(result);
            }, error => {
                reject(error);
            });
        });
    }
}